var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Menu'),_c('SubmitOrder',{attrs:{"couponList":_vm.couponList,"order":_vm.order,"cartIdList":[]}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }